// extracted by mini-css-extract-plugin
export default {"flex":"Card_flex__9gAu-","card_Wrapper":"Card_card_Wrapper__hftK0","card_heading":"Card_card_heading__xlEHM","temp_Variable":"Card_temp_Variable__31BJY"};